import * as React from 'react';

import * as styles from './DefaultContactsLayout.css';

export interface IDefaultContactsLayoutProps {
  contactsButton?: React.ReactNode;
  messageButton?: React.ReactNode;
  offerBookingButton?: React.ReactNode;
  messageButtonInSeparateRow?: boolean;
}

export const DefaultContactsLayout: React.FC<React.PropsWithChildren<IDefaultContactsLayoutProps>> = ({
  contactsButton,
  messageButton,
  offerBookingButton,
  messageButtonInSeparateRow = false,
}) => {
  return (
    <div className={styles['container']}>
      {contactsButton && (
        <>
          <div className={styles['buttons-row']}>
            <div className={styles['button']}>{contactsButton}</div>
            {messageButtonInSeparateRow ? null : messageButton}
          </div>
          {messageButtonInSeparateRow && (
            <div className={styles['buttons-row']}>
              <div className={styles['button']}>{messageButton}</div>
            </div>
          )}
        </>
      )}
      <div className={styles['buttons-row']}>
        {offerBookingButton && <div className={styles['button']}>{offerBookingButton}</div>}
      </div>
    </div>
  );
};
